import axios from 'axios';
import { createPostRequest } from '../../../helpers/request/request.js';
import { API_URLS } from '../../../configs/constants/urls.js';
import { appendXsrfToken } from '../../../helpers/request/utils.js';
import TokenService from '../../../helpers/request/tokens.js';
export const resetPasswordRequest = async (postData) => {
    try {
        const csrfFetched = await TokenService.getCsrfToken();
        if (!csrfFetched) {
            return {
                error: 'Failed to get CSRF token',
                status: null,
            };
        }
        const requestOptions = appendXsrfToken({});
        const response = await createPostRequest(API_URLS.BFF.RESET_PASSWORD, postData, requestOptions);
        if (response.data.success) {
            return response.data;
        }
        else {
            return {
                error: 'Unexpected error occurred',
                status: null,
            };
        }
    }
    catch (error) {
        console.error('Error in resetPasswordRequest:', error);
        if (axios.isAxiosError(error)) {
            const { response } = error;
            console.error('Axios error response:', response);
            if (!response) {
                return { error: 'No response from server', status: null };
            }
            const { status, data } = response;
            if (status === 400 || status === 500) {
                return {
                    error: status === 400 ? 'Validation failed' : 'Server error',
                    validations: data?.validations,
                    fieldErrors: data?.errors,
                    correlationId: data?.correlationId,
                    status,
                };
            }
            return {
                error: `Unhandled error: ${status}`,
                status,
            };
        }
        return {
            error: 'Unexpected error occurred',
            status: null,
        };
    }
};
//# sourceMappingURL=resetPassword.js.map